import styled from 'styled-components';

import { useIntl } from '@pass-frontend/common/i18n';
import { FacilityOffering } from '@pass-frontend/data-access/common/edge';
import {
  Coordinates,
  getDistanceInMiles,
} from '@pass-frontend/features/standalone/ui';
import { RdsButton } from '@pass-frontend/rally-energon-react';
import { RESPONSIVE_QUERY } from '@pass-frontend/utility/style-helpers';

export const StyledGymCard = styled.div`
  align-items: center;
  border-bottom: 1px solid #ccc;
  display: grid;
  grid-column-gap: 24px;
  grid-template-columns: 88px 1fr 160px;

  &:not(:first-child) {
    padding-top: 16px;
  }

  ${RESPONSIVE_QUERY.medium} {
    grid-template-columns: 64px 1fr 160px;
  }
`;

export const StyledImageWrapper = styled.div`
  align-items: center;
  border: 1px solid #e5e5e5;
  border-radius: 50%;
  height: 88px;
  justify-content: center;
  overflow: hidden;
  padding: 4px;
  white-space: nowrap;
  width: 100%;

  ${RESPONSIVE_QUERY.medium} {
    height: 64px;
  }
`;

interface GymCardProps {
  gym: FacilityOffering;
  fromCoordinates: Coordinates;
  handleConfirmAccessClick: (facilityId: string) => void;
}

export const GymCard = (props: GymCardProps) => {
  const { gym, fromCoordinates, handleConfirmAccessClick } = props;
  const { t } = useIntl();

  const handleConfirmClick = () => {
    handleConfirmAccessClick(gym.facilityId);
  };

  return (
    <StyledGymCard className="has-rds-pb-16">
      <StyledImageWrapper className="is-flex">
        <img
          src={gym.imageUrl || 'images/default-gym-logo.svg'}
          alt={gym.name}
        />
      </StyledImageWrapper>
      <div>
        {gym.name && (
          <p className="is-rds-body-2 is-marginless has-rds-text-grey-darker">
            {gym.name}
          </p>
        )}
        {gym.location?.address && (
          <p className="is-rds-body-3 is-marginless">{gym.location?.address}</p>
        )}
        <p className="is-rds-body-3 is-marginless has-rds-text-grey-dark is-flex">
          <div>{`${gym?.location?.city ? gym.location.city + ', ' : ''}
            ${gym?.location?.state}
            ${gym?.location?.zipcode}`}</div>
          &thinsp;
          <div>
            {`· ${t('facilityWeb.locationSearchResults.distance', {
              distance: getDistanceInMiles(gym, fromCoordinates),
            })}`}
          </div>
        </p>
      </div>
      <RdsButton variant="secondary" onClick={handleConfirmClick}>
        {t('facilityWeb.locationSearchResults.confirmAccess')}
      </RdsButton>
    </StyledGymCard>
  );
};
